// Genesis Utilities
import ParameterValidator from '@mvps-genesis/parameter-validator';

// Class Dependencies
import InputPasswordRequirementSetting from './InputPasswordRequirementSetting';

export default class InputPasswordRequirement {

	/**
	 * The form element being validated.
	 *
	 * @var	@mvps-genesis/parameter-validator
	 */
	#validator;

	/**
	 *
	 * @var	HTMLDivElement Reference to the requirement DOM element
	 */
	element;

	/**
	 *
	 * @var	Array<InputPasswordRequirementSetting> Reference to an array of `InputPasswordRequirementSetting` instances
	 */
	settings;

	/**
	 * Constructor of `InputPasswordRequirement`
	 * @return {undefined}
	 */
	constructor () {
		this.#validator = new ParameterValidator(this);
		this.element = this.#validator.isElement(`element`, this.createPasswordRequirementElement());
		this.settings = this.#validator.isArray(`settings`, this.createSettingElement());
	}

	/**
	 * Displays element
	 * @return {undefined}
	 */
	showElement () {
		this.element.classList.remove('u-hidden');
	}

	/**
	 * Will return the `passwordSettings` array. This is set in the cssui-html-profile.mvt
	 * @return {Array}
	 */
	getPasswordSettings () {
		return this.#validator.isArray(`window.mivaJS.passwordSettings`, window.mivaJS.passwordSettings);
	}

	/**
	 * Returns an array of `InputPasswordRequirementSetting` instances. Used to create the DOM in `InputPassword`
	 * @return {Array<InputPasswordRequirementSetting>}
	 */
	createSettingElement () {
		const settings = [];

		this.getPasswordSettings().forEach(setting => {
			settings.push(new InputPasswordRequirementSetting(setting));
		});

		return settings;
	}

	/**
	 * Creates the requirement DOM element
	 * @return {HTMLDivElement}
	 */
	createPasswordRequirementElement () {
		const requirementFragment = document.createRange().createContextualFragment(`<div class="g-form-password-requirements u-hidden"><div class="g-form-password-requirements__title">YOUR PASSSWORD MUST CONTAIN...</div></div>`);

		return requirementFragment.firstChild ? requirementFragment.firstChild : requirementFragment.firstElementChild;
	}
}
